/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type City = {
    zip: string;
    name: string;
    slug: string;
    federalStateCode: City.federalStateCode;
    countryCode: City.countryCode;
};
export namespace City {
    export enum federalStateCode {
        BW = 'BW',
        BY = 'BY',
        BE = 'BE',
        BB = 'BB',
        HB = 'HB',
        HH = 'HH',
        HE = 'HE',
        MV = 'MV',
        NI = 'NI',
        NW = 'NW',
        RP = 'RP',
        SL = 'SL',
        SN = 'SN',
        ST = 'ST',
        SH = 'SH',
        TH = 'TH',
    }
    export enum countryCode {
        DE = 'DE',
    }
}

